/* eslint-disable no-restricted-globals */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { camel } from 'radash';
import { getSessionFormData } from './sessionStorage';

declare const window: any;

export const getDataTracking = (value = '') => ({
  [`data-tracking`]: camel(value),
});

export interface Event {
  eventAction?: string;
  type?: string;
  pathname?: string;
  hash?: string;
  search?: string;
  pagename?: string;
  user?: {
    userId?: string;
    userName?: string;
    userType?: string;
  };
}

export interface Page {
  pathname?: string;
  search?: string;
  hash?: string;
}

export const setPrice = () => {
  const formData = getSessionFormData();

  if (!formData) return;

  if (String(formData?.donationOtherAmount)?.trim()?.length > 0) {
    return formData.donationOtherAmount;
  }

  return formData?.donationAmount;
};

export const setEvent = ({ pathname, search, user }: Event) => {
  if (window.stjude) {
    const { page, sysEnv } = window.stjude.digitalData;
    const newPathName = pathname?.substring(1);
    const confirmation = newPathName === 'confirmation';

    window.stjude.digitalData.sysEnv = {
      ...sysEnv,
      environment:
        sysEnv.environment === 'dev' ? 'staging' : sysEnv.environment,
    };

    const pathFromUrl = `${pathname || location?.pathname}${
      search || location?.search
    }`;

    window.stjude.digitalData.page = {
      ...page,
      path: pathFromUrl,
      subsection: confirmation ? newPathName : page?.subsection,
      title: 'p2p-donation-form',
      pageType: page?.title,
      pageName: confirmation
        ? 'p2p:donate:donate-to-st-jude:confirmation'
        : 'p2p:donate:donate-to-st-jude',
    };

    window.stjude.digitalData.user = user?.userId
      ? { ...user }
      : window.stjude.digitalData.user;
  } else {
    console.warn(
      'No stjude object found for adobe launch tracking, setEvent function is noop'
    );
  }
};

export const setTransaction = (transaction: Record<any, any>) => {
  if (window?.stjude) {
    window.stjude.digitalData.transaction = { ...transaction };
  }
};

export const setFormStartEvent = () => {
  const eventObj = { eventName: 'formStart', timeStamp: new Date() };
  if (window.location.hostname !== 'localhost') {
    if (window.stjude?.digitalData?.event) {
      if (
        !window.stjude.digitalData.event.find(
          (e: any) => e.eventName === 'formStart'
        )
      ) {
        window.stjude.digitalData.event.push(eventObj);
      }
    }
  }
};

export const useAnalytics = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    setEvent({
      pathname,
      search,
    });
  }, [pathname, search]);
};
